import * as React from 'react';
import { observer } from 'mobx-react';
import { Alert } from '@payscale/design';
import { configurationsStore } from 'utils/MobxDataManager/singletons';
import './cycleClosingAlert.scss';

export class CycleClosingAlert extends React.Component {
    render(): React.ReactNode {
        const config = configurationsStore.currentConvertedConfiguration;
        if (!config.cycleId || config.isClosing === false) {
            return null;
        }

        return (
            <Alert
                message={this.renderCycleClosingMessage()}
                level="info"
                close={true}
                className="nomst-cycle-closing-alert"
            />
        );
    }

    renderCycleClosingMessage(): React.ReactNode {
        const config = configurationsStore.currentConvertedConfiguration;
        return (
            <div className="nomst-cycle-closing-alert__message">
                <strong>This cycle is now closed</strong>
                <p>
                    The {config.configurationName} is locked.
                    Manager decisions are being processed and employee data is being updated in Insight Lab.
                </p>
            </div>
        );
    }
}

export default observer(CycleClosingAlert);